import { Button } from 'antd'

const StepsFooter = ({ pages, page, buttonfuncs, promiseLoading }) => (
	<div className='flex w-full flex-row items-center justify-end' key='footer'>
		{pages?.[page]?.buttons
			?.filter((button) => !(button?.type === 'next' && !pages?.[page + 1]))
			?.map((button, index) => {
				return (
					<Button
						id={button?.type}
						className={`${button?.className} ml-3`}
						style={{ height: 40 }}
						onClick={buttonfuncs[button?.type]}
						loading={promiseLoading}
						key={'button-' + index}
					>
						{button?.title}
					</Button>
				)
			})}
	</div>
)
export default StepsFooter
